__turbopack_context__.v({
  "center": "oqIDvq_center",
  "left": "oqIDvq_left",
  "logo": "oqIDvq_logo",
  "navbar": "oqIDvq_navbar",
  "progressBar": "oqIDvq_progressBar",
  "progressFill": "oqIDvq_progressFill",
  "quickStartNavbar": "oqIDvq_quickStartNavbar",
  "right": "oqIDvq_right",
  "spacer": "oqIDvq_spacer",
  "unitCounter": "oqIDvq_unitCounter",
});
